export function delay(waitTimeInMs) {
  return new Promise((resolve) => setTimeout(resolve, waitTimeInMs))
}
